(function () {
  "use strict";
  const studio = "https://studiov2.feltright.com";
  async function post(path, body) {
    const response = await fetch(studio + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!response.ok)
      throw new Error(
        "We could not save your design. Your selections are preserved; please try again.",
      );
    return response.json();
  }
  async function preview(shapes) {
    const core = window.WainscotingCore,
      b = core.bounds(shapes);
    const scale = Math.min(2, 1200 / Math.max(b.width, b.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.ceil((b.width + 40) * scale);
    canvas.height = Math.ceil((b.height + 40) * scale);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.scale(scale, scale);
    ctx.translate(20 - b.x, 20 - b.y);
    const images = await Promise.all(
      shapes.map(
        (s) =>
          new Promise((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = "anonymous";
            image.onload = () => resolve(image);
            image.onerror = () =>
              reject(
                new Error("A tile image could not load. Please try again."),
              );
            image.src = s.metadata.photo_url;
          }),
      ),
    );
    shapes.forEach((s, i) => {
      ctx.save();
      ctx.translate(s.x, s.y);
      ctx.rotate(((s.rotation || 0) * Math.PI) / 180);
      if (s.type === "arc") {
        const texture = core.arcTexture(images[i].naturalWidth, images[i].naturalHeight, s.width || 120, s.height || 60);
        ctx.rotate(texture.rotation * Math.PI / 180);
        ctx.drawImage(images[i], texture.x, texture.y, texture.width, texture.height);
      } else if (core.rotateTexture(s, images[i].naturalWidth, images[i].naturalHeight)) {
        ctx.translate(s.width - s.offsetX, -s.offsetY);
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(images[i], 0, 0, s.height, s.width);
      } else {
        ctx.drawImage(images[i], -s.offsetX, -s.offsetY, s.width, s.height);
      }
      ctx.restore();
    });
    return canvas.toDataURL("image/png");
  }
  async function save(shapes, name) {
    const b = window.WainscotingCore.bounds(shapes);
    const grid = {
      gridWidth: Math.ceil(b.width + 40),
      gridHeight: Math.ceil(b.height + 40),
      gridBgColor: "white",
      gridPattern: "square",
      startOffset: 20,
      shapeList: shapes,
    };
    const data = {
      grid,
      design_name: name,
      designWidth: b.width / 10 + " in",
      designHeight: b.height / 10 + " in",
      can_feature: false,
      commercial_project: false,
    };
    const result = await post("/api/designs", data);
    if (!result.success || !result.design?.id)
      throw new Error("Your design could not be saved. Please try again.");
    return { ...data, designId: result.design.id };
  }
  window.WainscotingCart = {
    async openStudio(shapes, name) {
      const saved = await save(shapes, name);
      return studio + "/?import=" + encodeURIComponent(saved.designId);
    },
    async add(shapes, name, sets) {
      const image = await preview(shapes);
      const data = await save(shapes, name);
      const cartTiles = window.WainscotingCore.cartTiles(shapes);
      const result = await post("/api/cart?parallel=true", {
        ...data,
        designName: name,
        image,
        cartTiles,
        cost: Object.values(cartTiles).reduce(
          (sum, tile) => sum + tile.cost,
          0,
        ),
        isCommercialProject: false,
        canFeature: false,
        attachmentOption: "adhesive",
      });
      if (!result.success || !result.cartAddPayload?.items?.length)
        throw new Error(
          "Your design is saved, but could not be added to cart. Please try again.",
        );
      // Preserve the server-signed component and price properties unchanged.
      const items = result.cartAddPayload.items.map((item) => ({
        ...item,
        quantity: Number(item.quantity) * sets,
      }));
      if (
        items.some(
          (item) =>
            !item.id ||
            !Number.isSafeInteger(item.quantity) ||
            item.quantity < 1,
        )
      )
        throw new Error("The cart returned an invalid quantity.");
      const route = (window.Shopify?.routes?.root || "/") + "cart/add.js";
      const response = await fetch(route, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(
          error.description ||
            "We could not add your design to cart. Please try again.",
        );
      }
      return response.json();
    },
  };
})();